window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.categoryRepo = function () {
    var url = 'api/categories?c=' + casino.config.guiCacheVerzija;

    // radimo cache igri, jednom je dosta
    var categoriesPromise = null;

    var list = function () {

        if (!categoriesPromise) {
            categoriesPromise = fetch(url)
                .then(casino.repos.base.checkResponse)
                .then(function (response) {
                    return response.json();
                })
                .catch(casino.repos.base.handleNetworkException);
        }

        return categoriesPromise;
    };

    return {
        list: list
    }

}();